export class ItemDefinition {
    public ItemId: number;
    public ItemName: string;
    public ItemPrice: number;
    public Enabled: string;
}
